import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

const ScheduifyWordmark: React.FC<TypographyProps> = (props) => (
  <Typography
    {...props}
    sx={{ fontFamily: 'Shrikhand, cursive', color: '#1976d2', fontWeight: 400, ...props.sx }}
  >
    Scheduify
  </Typography>
);

export default ScheduifyWordmark;
